/**
 * @file Maintenance notice (1.13.6).
 *
 * Rendered instead of the whole app when `maintenanceMode` is on in the
 * runtime configuration, so the page can be taken down from the blueprint
 * without a release. It deliberately mounts no providers and makes no API
 * call: the usual reason for switching this on is that the thing it would
 * call is the thing being worked on.
 */
import { MAIN_ID } from '../../app/layout/AppShell';
import { Container } from '../../components/ui/Container';
import { Eyebrow } from '../../components/ui/Eyebrow';
import { Stack } from '../../components/ui/Stack';
import styles from '../verify/verify.module.css';

import type { ReactElement } from 'react';

/** The maintenance screen. */
export function Maintenance(): ReactElement {
  return (
    <main id={MAIN_ID}>
      <Container width="narrow">
        <Stack gap={6}>
          <header className={styles.header}>
            <Eyebrow>Early access</Eyebrow>
            <h1>Back shortly</h1>
            <p>
              We are making a change to this page. Nothing you have already bought is affected.
              Please try again in a few minutes.
            </p>
          </header>
        </Stack>
      </Container>
    </main>
  );
}
